import styled from 'styled-components';
import { GraniteGray } from '../../../styling/theme';

const Kbd = styled.div`
  font-size: 12px;
  color: ${GraniteGray};
`;

const Shortcut = ({ children }) => {
  return <Kbd>{children}</Kbd>;
};
export default Shortcut;
